<template>
    <div class="available-functions-container-new">
        <div class="available-functions">
            <p class="heading">{{ $t('landing-page.functions') }}</p>
            <p class="description">
                {{ $t('landing-page.functions-description') }}
            </p>
        </div>

        <v-row class="function-cards" dense>
            <!-- Colleagues Present -->
            <v-col cols="12" md="6" sm="6" lg="3">
                <v-card class="function-card" elevation="2">
                    <div class="card-content">
                        <div class="circle-progress-wrapper">
                            <v-progress-circular :model-value="colleaguesPresent" :size="60" :width="6" color="blue"
                                bg-color="grey-lighten-3">
                                <small>{{ colleaguesPresent }}%</small>
                            </v-progress-circular>
                        </div>
                        <div class="function-info">
                            <p class="title">{{ $t('landing-page.colleagues') }}</p>
                            <div class="subtitle">
                                <span class="dot blue"></span>
                                <span style="margin-left:4px">
                                    {{ $t('landing-page.present') }}
                                </span>
                                &nbsp; &nbsp; &nbsp;
                                <span class="dot gray"></span>
                                <span style="margin-left:4px">
                                    {{ $t('landing-page.not-present') }}
                                </span>

                            </div>
                        </div>
                    </div>
                </v-card>
            </v-col>

            <!-- Desks Available -->
            <v-col cols="12" md="6" sm="6" lg="3">
                <v-card class="function-card" elevation="2">
                    <div class="card-content">
                        <div class="circle-progress-wrapper">
                            <v-progress-circular :model-value="desksAvailable" :size="60" :width="6" color="green"
                                bg-color="red">
                                <small>{{ desksAvailable }}%</small>
                            </v-progress-circular>
                        </div>
                        <div class="function-info">
                            <p class="title">{{ $t('landing-page.desks-available') }}</p>
                            <div class="subtitle">
                                <span class="dot green"></span> <span style="margin-left:4px">
                                    {{ $t('landing-page.available') }}
                                </span>
                                &nbsp; &nbsp; &nbsp;
                                <span class="dot red"></span>
                                <span style="margin-left:4px">
                                    {{ $t('landing-page.booked') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </v-card>
            </v-col>

            <!-- Your Attendance -->
            <v-col cols="12" md="6" sm="6" lg="3">
                <v-card class="function-card" elevation="2">
                    <div class="card-content">
                        <div class="function-info full-width">
                            <p class="title">{{ $t('landing-page.attendance') }}</p>
                            <p class="subtitle">{{ $t('landing-page.attendance-description') }}</p>
                            <v-progress-linear :model-value="20" color="orange" height="6" rounded class="mt-2"
                                background-color="grey-lighten-3" />
                        </div>
                    </div>
                </v-card>
            </v-col>

            <!-- Quick Action -->
            <v-col cols="12" md="6" sm="6" lg="3">
                <v-card class="function-card" elevation="2" @click="dialog = true">
                    <div class="card-content">
                        <div class="quick-icon">
                            <v-icon size="30" color="blue">mdi-flash-outline</v-icon>
                        </div>
                        <div class="function-info" @click="dialog = true" style="cursor: pointer">
                            <p class="title">{{ $t('landing-page.quick-actions') }}</p>
                            <p class="subtitle">
                                {{ $t('landing-page.quick-actions-description') }}
                                <span style="color: #4578f4; font-weight: bold;">&nbsp;></span>
                            </p>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" width="300">
            <v-card style="border-radius: 16px; box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);">
                <v-card-title class="text-h6" style="padding: 16px 20px; font-weight: 600; color: #1e293b;">
                    {{ $t('landing-page.quick-actions') }}
                </v-card-title>

                <v-divider />

                <v-list>
                    <v-list-item v-for="(option, index) in quickActionOptions" :key="index"
                        @click="handleQuickAction(option)"
                        style="padding: 12px 20px; cursor: pointer; transition: background 0.2s;"
                        @mouseover="hovered = index" @mouseleave="hovered = null"
                        :style="hovered === index ? 'background-color: #f1f5f9; border-radius: 8px;' : ''">
                        <v-list-item-title style="font-size: 15px; color: #334155; font-weight: 500;">
                            {{ option.label }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showChatBotDialog" max-width="600">
            <v-card>
                <v-card-title class="d-flex justify-space-between">
                    <span>{{ $t('menu.chatbot-assistant') }}</span>
                    <v-btn icon @click="showChatBotDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

            </v-card>
        </v-dialog>

    </div>
</template>


<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router'


const colleaguesPresent = ref(80)
const desksAvailable = ref(20)
const { locale, t } = useI18n()
const router = useRouter()

const openBooking = () => {
    console.log('openBooking')
    router.push({ name: 'PoisListView' })
}
const dialog = ref(false)
const showChatBotDialog = ref(false)
const hovered = ref(null)
const quickActionOptions = [
    {
        label: t('booking.bookings'),
        route: { name: 'UserBookings' }
    },
    {
        label: t('booking.book-now-tab'),
        route: { name: 'BookingPoisList' }
    },
    {
        label: t('menu.ask_help.title'),
        route: { name: '' }
    },

]

const handleQuickAction = (option) => {
    dialog.value = false
    if (option.label === t('menu.ask_help.title')) {
        showChatBotDialog.value = true
        return

    }
    router.push(option.route)
}




</script>

<style scoped>
.available-functions-container-new {
    background: #e8eef6;
    padding: 35px 45px;
    margin-top: 25px;
}

.available-functions .heading {
    font-weight: bold;
    font-size: 1.5rem;
}

.available-functions .description {
    color: #718096;
    font-size: 1.1rem;
    margin-bottom: 20px;
}

.function-cards {
    margin-top: 10px;
}

.function-card {
    border-radius: 14px;
    padding: 20px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    /* smooth transition */
    cursor: pointer;
    /* hand cursor */
    background: white;
    /* make sure card background is clean */
}

.function-card:hover,
.function-card:active {
    transform: translateY(-4px);
    /* move slightly up */
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    /* deeper shadow */
    background-color: #f9fafb;
    /* light background highlight */
}

.card-content {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
}

.circle-progress-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.function-info {
    text-align: left;
    flex: 1;
}

.full-width {
    width: 100%;
}

.title {
    font-weight: bold;
    margin: 0;
    font-size: 18px;
}

.subtitle {
    font-size: 14px;
    margin-top: 4px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    display: inline-block;
}

.dot.blue {
    background-color: #3b82f6;
}

.dot.green {
    background-color: #10b981;
}

.dot.gray {
    background-color: #d1d5db;
}

.dot.red {
    background-color: #ef4444;
}

.quick-icon {
    width: 52px;
    height: 52px;
    border-radius: 10px;
    background: #eef4ff;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* 📱 Responsive Design */
@media (max-width: 992px) {


    .available-functions .heading {
        font-size: 1.3rem;
    }

    .available-functions .description {
        font-size: 1rem;
    }

    .title {
        font-size: 16px;
    }

    .subtitle {
        font-size: 13px;
    }
}

@media (max-width: 804px) {
    .available-functions-container-new {
        padding: 20px;
    }
}
</style>